import React, { Component } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  matchPath,
} from "react-router-dom";
import Delivery from "../../Pages/Delivery/Delivery";
import DeliveryForm from "../../Pages/Delivery/DeliveryForm";
import LayoutScreen from "../../Pages/Layout/LayoutScreen";
import Payment from "../../Pages/Payment/Payment";
import PurchaseOrder from "../../Pages/PurchaseOrder/Purchase";
import PurchaseForm from "../../Pages/PurchaseOrder/PurchaseForm";
import SalesOrder from "../../Pages/SalesOrder/Sales";
import SalesForm from "../../Pages/SalesOrder/SalesForm";
import ReceiptView from "../../Pages/Transfer/ReceiptView";
import Transfer from "../../Pages/Transfer/Transfer";
import TransferForm from "../../Pages/Transfer/TransferForm";
import TransferView from "../../Pages/Transfer/TransferView";
import User from "../../Pages/User/User";
import { useDispatch, useSelector } from "react-redux";
import ReceiptForm from "../../Pages/Transfer/ReceiptForm";
import PreviewHtml from "../../Pages/SalesOrder/PreviewHtml";
import PaymentForm from "../../Pages/Payment/PaymentForm";
import RolePage from "../../Pages/User/RolePage";
import { getRoleById } from "../../Service/UserService";
import Swal from "sweetalert2";
import HomePage from "../../Pages/Home/HomePage";
import { CLEAR_REFRESH_PATH } from "../../Redux/Action/AuthAction";
import ApprovalSO from "../../Pages/SalesOrder/Approval";
import ApprovalSOForm from "../../Pages/SalesOrder/ApprovalSOForm";
import NotFound from "../../Pages/Error/NotFound";
import Profile from "../../Pages/User/Profile";
import EStatement from "../../Pages/EStatement";
import Stock from "../../Pages/Stock/Stock";
import TransactionsMI from "../../Pages/Logs/TransactionsMI";
import TransactionsMHC from "../../Pages/Logs/TransactionsMHC";
import MIReadyStock from "../../Pages/Stock/MIReadyStock";
import Banks from "../../Pages/Banks/Banks";
import Withdrawal from "../../Pages/Withdrawal/Withdrawal";
import BalanceInquiry from "../../Pages/Payment/BalanceInquiry";
import SyncPage from "../../Pages/General/Sync";

const routeList = [
  "/salesorder",
  "/salesorder/:pageState",
  "/salesorder/:pageState/:id_so",
  "/salesorder/payment-verification",
  "/purchaseorder/payment-verification",
  "/preview",
  "/salesorderapproval",
  "/salesorderapproval/view/:id_so",
  "/purchaseorder",
  "/purchaseorder/:pageState",
  "/purchaseorder/:pageState/:id_po",
  "/delivery",
  "/delivery/:pageState",
  "/delivery/:pageState/:id_delivery",
  "/inventorytransfer",
  "/inventorytransfer/create",
  "/inventorytransfer/view/:id",
  "/receipttransfer/:id",
  "/receipttransfer/create/:id",
  "/operationalcost",
  "/operationalcost/:pageState/:id_payment",
  "/operationalcost/:pageState",
  "/productstock/branch",
  "/mistock",
  "/dealerbanks",
  "/logs/transactions/mi",
  "/logs/transactions/mhc",
  "/users",
  "/roles",
  "/sync",
  "/profile",
  "/payment-gateway/withdrawal",
  "/payment-gateway/balance-inquiry",
];

const tryRequire = (path) => {
  let match = 0;

  for (let key in routeList) {
    if (matchPath(routeList[key], path)) {
      match++;
    }
  }

  if (match > 0) {
    return true;
  } else {
    return false;
  }
};

const ToHome = () => {
  const refreshPath = useSelector(({ auth: { refreshPath } }) => refreshPath);
  const path = refreshPath
    .replace("login", "dashboard")
    .split("/")
    .slice(0, 6)
    .join("/");

  if (tryRequire(path)) {
    return <Navigate to={path} replace={true} />;
  } else {
    return <Navigate to="/not-found" replace={true} />;
  }
};

const menus = {
  salesorder: [
    <Route path="/salesorder" element={<SalesOrder />} />,
    <Route path="/salesorder/:pageState" element={<SalesForm />} />,
    <Route path="/salesorder/:pageState/:id_so" element={<SalesForm />} />,
    <Route path="/preview" element={<PreviewHtml />} />,
  ],
  salesorderapproval: [
    <Route path="/salesorderapproval" element={<ApprovalSO />} />,
    <Route
      path="/salesorderapproval/view/:id_so"
      element={<ApprovalSOForm />}
    />,
  ],
  purchaseorder: [
    <Route path="/purchaseorder" element={<PurchaseOrder />} />,
    <Route path="/purchaseorder/:pageState" element={<PurchaseForm />} />,
    <Route
      path="/purchaseorder/:pageState/:id_po"
      element={<PurchaseForm />}
    />,
  ],
  purchaseorderapproval: [
    <Route path="/purchaseorder" element={<PurchaseOrder />} />,
    <Route path="/purchaseorder/:pageState" element={<PurchaseForm />} />,
    <Route
      path="/purchaseorder/:pageState/:id_po"
      element={<PurchaseForm />}
    />,
  ],
  delivery: [
    <Route path="/delivery" element={<Delivery />} />,
    <Route path="/delivery/:pageState" element={<DeliveryForm />} />,
    <Route
      path="/delivery/:pageState/:id_delivery"
      element={<DeliveryForm />}
    />,
  ],
  inventorytransfer: [
    <Route path="/inventorytransfer" element={<Transfer />} />,
    <Route path="/inventorytransfer/create" element={<TransferForm />} />,
    <Route path="/inventorytransfer/view/:id" element={<TransferView />} />,
    <Route path="/receipttransfer/:id" element={<ReceiptView />} />,
    <Route path="/receipttransfer/create/:id" element={<ReceiptForm />} />,
  ],
  operationalcost: [
    <Route path="/operationalcost" element={<Payment />} />,
    <Route
      path="/operationalcost/:pageState/:id_payment"
      element={<PaymentForm />}
    />,
    <Route path="/operationalcost/:pageState" element={<PaymentForm />} />,
  ],
  dealerbanks: [<Route path="/dealerbanks" element={<Banks />} />],
  productstock: [<Route path="/productstock/branch" element={<Stock />} />],
  mistock: [<Route path="/mistock" element={<MIReadyStock />} />],
  user: [
    <Route path="/users" element={<User />} />,
    <Route path="/users/profile" element={<Profile />} />,
  ],
  role: [<Route path="/roles" element={<RolePage />} />],
  sync: [<Route path="/sync" element={<SyncPage />} />],
  transactionmi: [
    <Route path="/logs/transactions/mi" element={<TransactionsMI />} />,
  ],
  transactionmhc: [
    <Route path="/logs/transactions/mhc" element={<TransactionsMHC />} />,
  ],
  withdrawal: [
    <Route path="/payment-gateway/withdrawal" element={<Withdrawal />} />,
    <Route
      path="/payment-gateway/balance-inquiry"
      element={<BalanceInquiry />}
    />,
  ],
};

const HomeNavigation = () => {
  const userInfo = useSelector((state) => state.auth.userInfo);
  if (userInfo.privileges) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LayoutScreen />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/dashboard" element={<HomePage />} />
            {userInfo.privileges.map(
              (item, i) => item.access && menus[item.name]
            )}
            <Route path="/not-found" element={<NotFound />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/*" element={<ToHome />} />
          </Route>
          <Route path="/estatement/:modul/:id_so" element={<EStatement />} />
        </Routes>
      </BrowserRouter>
    );
  } else {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LayoutScreen />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/dashboard" element={<HomePage />} />
            <Route path="/not-found" element={<NotFound />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/*" element={<ToHome />} />
          </Route>
          <Route path="/estatement/:modul/:id_so" element={<EStatement />} />
        </Routes>
      </BrowserRouter>
    );
  }
};

export default HomeNavigation;
